module.exports = __webpack_public_path__ + "img/privilege15.999032cb.png";